var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _circle, _rect30, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8246 4.78947H33.8129C36 4.78947 37.7895 6.49474 37.7895 8.57895V35.1053C37.7895 37.1895 36 38.8947 33.8129 38.8947H5.97661C3.76959 38.8947 2 37.1895 2 35.1053L2.01988 8.57895C2.01988 6.49474 3.76959 4.78947 5.97661 4.78947H7.96491V1H11.9415V4.78947H27.848V1H31.8246V4.78947ZM5.97661 35.1053H33.8129V14.2632H5.97661V35.1053Z",
    fill: "#009a80"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3906,
    y: 17.3311,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83594,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83594,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83594,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83594,
    y: 28.4375,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1641,
    y: 17.3311,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6133,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6133,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6133,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6133,
    y: 28.4375,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9414,
    y: 17.3311,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3906,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3906,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#4C6BFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3906,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3906,
    y: 28.4375,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7188,
    y: 17.3311,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 20.1074H19.5524V21.4958H18.1641V20.1074Z",
    fill: "#009a80"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1641,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1641,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1641,
    y: 28.4375,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7188,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7188,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7188,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4961,
    y: 17.3311,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9414,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9414,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9414,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9414,
    y: 28.4375,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4961,
    y: 20.1074,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4961,
    y: 22.8848,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4961,
    y: 25.6611,
    width: 1.38833,
    height: 1.38833,
    fill: "#009a80"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 25.168,
    y: 27.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#4C6BFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.668,
    cy: 34,
    r: 5.75,
    fill: "white",
    stroke: "#4C6BFF",
    strokeWidth: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3359,
    y: 30,
    width: 1,
    height: 4,
    fill: "#4C6BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0039 36.457L34.2734 37.1399L31.3378 33.9996L32.0684 33.3167L35.0039 36.457Z",
    fill: "#4C6BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreen);
export default __webpack_public_path__ + "static/media/calendar_green.436493d58cb35756c6c36a24f6cf146d.svg";
export { ForwardRef as ReactComponent };